import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import Models from "./pages/Models";
import Innovation from "./pages/Innovation";
import About from "./pages/About";
import Newsroom from "./pages/Newsroom";
import Contact from "./pages/Contact";
import TestDrive from "./pages/TestDrive";
import Service from "./pages/Service";
import Worldwide from "./pages/Worldwide";
import BlogDetail from "./pages/BlogDetail";
import ModelDetail from "./pages/ModelDetail";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import QuickLinks from "./components/QuickLinks";
import { Toaster } from "./components/ui/toaster";
import Imagecomp from "./pages/Imagecomp";
import Overview from "./pages/about/Overview";
import GGS from "./pages/about/GGS";
import Vision from "./pages/about/Vision";
import History from "./pages/about/History";
import AfterSalesService from "./pages/about/AfterSalesService";
import Careers from "./pages/about/Careers";
import JobDetail from "./pages/about/JobDetail";
import CapitalBeautyPage from "./pages/about/CapitalBeautyPage";
import ConceptCarPage from "./pages/about/ConceptCarPage";
import OffRoadPage from "./pages/about/OffRoadPage";
import ResearchDevelopmentPage from "./pages/about/ResearchDevelopmentPage";
import ServiceCentres from "./pages/ServiceCentres";
import BookService from "./pages/BookService";
import Feedback from "./pages/Feedback";
import BJ30 from "./pages/BJ30";
import BJ40Plus from "./pages/BJ40Plus";
import BJ40Pro from "./pages/BJ40Pro";
import U5Plus from "./pages/U5Plus";
import Gallery from "./pages/Gallery";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import LandingPage from "./pages/LandingPage";
import ScrollToTop from "./components/ScrollToTop";
import { LanguageProvider } from "./context/LanguageContext";
import { config } from "./config";

function Layout() {
  const location = useLocation();
  const hideLayout = location.pathname.startsWith("/landing-page");

  return (
    <>
      {!hideLayout && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/models" element={<Models />} />
        <Route path="/innovation" element={<Innovation />} />
        <Route path="/about" element={<About />} />
        <Route path="/about/overview" element={<Overview />} />
        <Route path="/about/ggs" element={<GGS />} />
        <Route path="/about/vision" element={<Vision />} />
        <Route path="/about/after-sales-service" element={<AfterSalesService />} />
        <Route path="/connect/careers" element={<Careers />} />
        <Route path="/careers/:id" element={<JobDetail />} />
        <Route path="/history/off-road" element={<OffRoadPage />} />
        <Route path="/history/baic" element={<History />} />
        <Route path="/newsroom" element={<Newsroom />} />
        <Route path="/connect/contact-us" element={<Contact />} />
        <Route path="/test-drive" element={<TestDrive />} />
        <Route path="/car-service" element={<Service />} />
        <Route path="/service-centers" element={<ServiceCentres type="service" />} />
        <Route path="/show-rooms" element={<ServiceCentres type="showroom" />} />
        <Route path="/book-service" element={<BookService />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/worldwide" element={<Worldwide />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/off-road/bj30-hybrid" element={<BJ30 />} />
        <Route path="/off-road/bj40-honor" element={<BJ40Plus />} />
        <Route path="/off-road/bj40-pro" element={<BJ40Pro />} />
        <Route path="/sedan/u5-plus" element={<U5Plus />} />
        <Route path="/models/:slug" element={<ModelDetail />} />
        <Route path="/image" element={<Imagecomp />} />
        {config.showGallery && <Route path="/gallery" element={<Gallery />} />}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/contact-us" element={<Navigate to="/connect/contact-us" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!hideLayout && (
        <>
          <Footer />
          <QuickLinks />
        </>
      )}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Layout />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
